import { render, staticRenderFns } from "./Amenitiz.vue?vue&type=template&id=07eddc84&scoped=true"
import script from "./Amenitiz.vue?vue&type=script&lang=js"
export * from "./Amenitiz.vue?vue&type=script&lang=js"
import style0 from "./Amenitiz.vue?vue&type=style&index=0&id=07eddc84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eddc84",
  null
  
)

export default component.exports